<template>
  <div class="right-tile">
    <div v-for="(card, index) in perUserPerMonth" :key="card.id" class="mb-2">
      <Card class="card">
        <div class="card-container">
          <div class="mt-3 text-center icon-wrapper">
            <GraphCalculatorIcon />
          </div>
          <div>
            <p class="card-title">{{ perUserPerMonth[index].title }}</p>
            <p class="card-info">Per user/month</p>
            <p class="card-data">${{ displayValueSwitch(card.id) }}</p>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '../global/Card.vue';
import GraphCalculatorIcon from '../../assets/icons/performance-graph-calculator.svg';
import { NumberOfdigitsafterDecimalIsOne } from '../../services/lib/NumberofDigitsafterDecimals';

export default {
  name: 'VerticalTiles',
  data() {
    return {
      perUserPerMonth: [
        { id: 'cvad', title: 'Citrix cost', amount: 0 },
        { id: 'gcp', title: 'Google Cloud cost', amount: 0 },
        { id: 'total', title: 'Total cost', amount: 0 },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  components: {
    Card,
    GraphCalculatorIcon,
  },
  methods: {
    displayValueSwitch(id) {
      switch (id) {
        case 'cvad':
          return 10;

        case 'gcp':
          if (
            NumberOfdigitsafterDecimalIsOne(
              Number(this.data.gcpCostPerYear / 12).toFixed(2)
            )
          ) {
            return Number((this.data.gcpCostPerYear / 12).toFixed(2)) + '0';
          }

          return Number(this.data.gcpCostPerYear / 12).toFixed(2);

        case 'total':
          if (
            NumberOfdigitsafterDecimalIsOne(
              Number(
                Number(
                  Number(this.data.totalCvadThreeYear) / this.data.users / 36
                ) +
                  this.data.gcpCostPerYear / 12
              ).toFixed(2)
            )
          ) {
            return (
              Number(
                Number(
                  Number(this.data.totalCvadThreeYear) / this.data.users / 36
                ) +
                  this.data.gcpCostPerYear / 12
              ).toFixed(2) + '0'
            );
          }
          return Number(
            this.data.totalCvadThreeYear / this.data.users / 36 +
              this.data.gcpCostPerYear / 12
          ).toFixed(2);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  padding-top: 0%;
}
.text-lighter {
  font-weight: 100;
  color: $light;
}
.card-container {
  display: flex;
  grid-gap: 30px;
  @media print {
    display: -webkit-box !important;
  }

  .icon-wrapper {
    @media print {
      width: 50px !important;
      margin-right: 30px !important;
    }
  }
}
.card-wrapper {
  padding: 27px;
  @media print {
    padding: 17px;
  }
}
.card-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0;
}

.card-info {
  @extend .text-lighter;
  font-size: 20px;
  margin: 2px;
}

.card-data {
  font-size: 28px;
  margin-bottom: 0;
  color: $primary;
  margin: 0;
}
</style>
